import { render } from "./CostiRicaviSottoProgetto.vue?vue&type=template&id=97d5fe46&ts=true"
import script from "./CostiRicaviSottoProgetto.vue?vue&type=script&lang=ts"
export * from "./CostiRicaviSottoProgetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__